<template>
	<div class="loading-widget">
		<div v-for="i in 4" :key="i"
			:class="'rect'+i">
		</div>
	</div>
</template>

<script>
export default {
	name: 'loading-widget',

	props: {
		color: {
			type: String,
			default: 'white'
		}
	}
}
</script>

<style lang="stylus" scoped>
.loading-widget
	text-align: center

	&>div
		height: 100%
		width: 15%
		display: inline-block

		position: relative

		margin: auto 5%

		background-color: currentColor
		color: inherit
		
		animation: loading-widget-anim 1.2s infinite ease-in-out

	.rect2
		animation-delay: -1.1s

	.rect3
		animation-delay: -1.0s

	.rect4
		animation-delay: -0.9s

	.rect5
		animation-delay: -0.8s

@keyframes loading-widget-anim
	0%, 40%, 100%
		transform: scaleY(0.5)
	20%
		transform: scaleY(1.0)
</style>